module.exports = __webpack_public_path__ + "static/media/bg-spots.5d6f83e9.png";